/*=========================================================================================
                          File Name: globalComponents.js
                          Description: Here you can register components globally
                        ==========================================================================================*/

import Vue from 'vue';

import MsButton from './components/msbutton/msButton.vue';
Vue.component(MsButton.name, MsButton);
import MsInput from './components/msinput/msInput.vue';
Vue.component(MsInput.name, MsInput);
import MsCheckbox from './components/mscheckbox/msCheckbox.vue';
Vue.component(MsCheckbox.name, MsCheckbox);
import MsRadio from './components/msradio/msRadio.vue';
Vue.component(MsRadio.name, MsRadio);
import MsDatepicker from './components/msdatepicker/MsDatePicker.vue';
Vue.component(MsDatepicker.name, MsDatepicker);
import MsDatePickerV2 from './components/msdatepicker/MsDatePickerV2.vue';
Vue.component(MsDatePickerV2.name, MsDatePickerV2);
import MsTextArea from './components/msTextarea/MsTextArea.vue';
Vue.component(MsTextArea.name, MsTextArea);
import MsDisplayFilter from './components/msDisplayFilter/msDisplayFilter.vue';
Vue.component(MsDisplayFilter.name, MsDisplayFilter);

import MsSwitch from './components/msSwitch/MsSwitch.vue';
Vue.component(MsSwitch.name, MsSwitch);
import MsNumber from './components/msnumber/msNumber.vue';
Vue.component(MsNumber.name, MsNumber);
import MsDropDown from './components/msdropdown/msDropdown.vue';
Vue.component(MsDropDown.name, MsDropDown);
import MsDropdownItem from './components/msdropdown/msDropdownItem.vue';
Vue.component(MsDropdownItem.name, MsDropdownItem);
import MsTagNew from './components/msTagNew/MsTagNew.vue';
Vue.component(MsTagNew.name, MsTagNew);

//Ông popup thì sẽ không cấy trực tiếp vào form mà xử lý show động
import MsPopup from './components/mspopup/MsPopup.vue';
Vue.component(MsPopup.name, MsPopup);
import MsPopupV2 from './components/mspopup/MsPopupV2.vue';
Vue.component(MsPopupV2.name, MsPopupV2);
import MsPopupV3 from './components/mspopup/MsPopupV3.vue';
Vue.component(MsPopupV3.name, MsPopupV3);
import MsComboBox from './components/mscombobox/msCombobox.vue';
Vue.component(MsComboBox.name, MsComboBox);
import MsComboBoxV2 from './components/mscombobox/msComboboxV2.vue';
Vue.component(MsComboBoxV2.name, MsComboBoxV2);
import MsComboboxWithDifferentValue from './components/mscombobox/msComboboxWithDifferentValue.vue';
Vue.component(MsComboboxWithDifferentValue.name, MsComboboxWithDifferentValue);
import msGridViewer from '@/components/msgridviewerx/msGridViewer.vue';
Vue.component(msGridViewer.name, msGridViewer);
import msGridViewerV2 from '@/components/msgridviewerx/msGridViewerV2.vue';
Vue.component(msGridViewerV2.name, msGridViewerV2);
import msTreeViewer from '@/components/msTreeViewer/msTreeViewer.vue';
Vue.component(msTreeViewer.name, msTreeViewer);
import msNoData from '@/components/msNoData/msNoData.vue';
Vue.component(msNoData.name, msNoData);
import msTreeViewerV2 from '@/components/msTreeViewer/msTreeViewerV2.vue';
Vue.component(msTreeViewerV2.name, msTreeViewerV2);
import msConfigLayout from '@/components/msConfigLayout/msConfigLayout.vue';
Vue.component(msConfigLayout.name, msConfigLayout);
import msActionIconButton from '@/components/msActionIconButton/msActionIconButton.vue';
Vue.component(msActionIconButton.name, msActionIconButton);
import msDaterange from '@/components/msdaterange/msDaterange.vue';
Vue.component(msDaterange.name, msDaterange);
import msGridEditor from '@/components/msgrideditor/msGridEditor.vue';
Vue.component(msGridEditor.name, msGridEditor);
import msGridEditorV2 from '@/components/msgrideditor/msGridEditorV2.vue';
Vue.component(msGridEditorV2.name, msGridEditorV2);
import msGridEditorV3 from '@/components/msgrideditor/msGridEditorV3.vue';
Vue.component(msGridEditorV3.name, msGridEditorV3);
import msValidate from '@/components/msValidate/msValidate.vue';
Vue.component(msValidate.name, msValidate);
import msInputSearch from '@/components/msinputsearch/msInputSearch.vue';
Vue.component(msInputSearch.name, msInputSearch);
import msInputSearchAutoComplete from '@/components/msinputsearch/msInputSearchAutoComplete.vue';
Vue.component(msInputSearchAutoComplete.name, msInputSearchAutoComplete);

import msTab from '@/components/msTab/msTab.vue';
Vue.component(msTab.name, msTab);

import msSegmented from '@/components/msTab/msSegmented.vue';
Vue.component(msSegmented.name, msSegmented);

import msInputRange from '@/components/msInputRange/MsInputRange.vue';
Vue.component(msInputRange.name, msInputRange);

import MsComboBoxMulti from './components/msComboboxMultiple/msComboboxMultiple.vue';
Vue.component(MsComboBoxMulti.name, MsComboBoxMulti);

import MsComboboxMultipleV2 from './components/msComboboxMultiple/msComboboxMultipleV2.vue';
Vue.component(MsComboboxMultipleV2.name, MsComboboxMultipleV2);

import msInputMulti from '@/components/msInputMulti/msInputMulti.vue';
Vue.component(msInputMulti.name, msInputMulti);

import MsAutoComboboxCompleteMulti from './components/msComboboxMultiple/MsAutoComboboxCompleteMulti.vue';
Vue.component(MsAutoComboboxCompleteMulti.name, MsAutoComboboxCompleteMulti);

import MsAutoComboboxComplete from './components/mscombobox/MsAutoComboboxComplete.vue';
Vue.component(MsAutoComboboxComplete.name, MsAutoComboboxComplete);

import MsCircleBarProcess from './components/msCircleBar/MsCircleBarProcess.vue';
Vue.component(MsCircleBarProcess.name, MsCircleBarProcess);

import MsLoading from './components/msLoading/MsLoading.vue';
Vue.component(MsLoading.name, MsLoading);

import MsComboboxOperator from './components/mscombobox/msComboboxOperator.vue';
Vue.component(MsComboboxOperator.name, MsComboboxOperator);

import MsTimer from './components/msTimer/msTimer.vue';
Vue.component(MsTimer.name, MsTimer);
